import React, { useState, useEffect } from "react";
import { Spinner } from "reactstrap";

const Evolution = ({ ...props }) => {
    const [dataa, setdataa] = useState([])
    const [totall, settotall] = useState([])
    const [load, setload] = useState(true)
    const getdata = async () => {
        const sendData = {
            ParametersId: Number(props.parametersId),
            UserId: Number(props.UserId),
            ToYearId: Number(props.toyear),
            ToMonthId: Number(props.tomonth),
            YearId: Number(props.year),
            MonthId: Number(props.Month)
        }
        ////console.log(sendData)
        await fetch(process.env.REACT_APP_API_LINK+'api/NCSCDA/Report', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    if (data.length > 0) {
                        setdataa(data[0])
                    } else {
                        setdataa([])
                    }
                    ////console.log(data)
                setload(false)
                })

    };
    const Total = async () => {
        const sendData = {
            ParametersId: Number(props.parametersId),
            UserId: Number(props.UserId),
            YearId: Number(props.year),
            MonthId: Number(props.Month)
        }

        await fetch(process.env.REACT_APP_API_LINK + 'api/NCSCDA/Reporttotal', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    if (data.length > 0) {
                        settotall(data[0])
                    }
                    setload(false)
                })

    };

    useEffect(() => {
        setload(true)
        getdata()
        Total()
    }, [props.parametersId, props.UserId, props.generate])
    
  
    return (
        <>
            {load ? <Spinner color="success" /> :
                Number(props.parametersId) === 218?
                     <>

                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                            <label> {dataa.genderMale4 >= 0 ? dataa.genderMale4 : 0}</label>

                        </td>

                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                            <label> {dataa.genderFemale5 >= 0 ? dataa.genderFemale5 : 0}</label>

                        </td>

                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                            <label> {dataa.genderTransgender6 >= 0 ? dataa.genderTransgender6 : 0}</label>

                        </td>

                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                            <label> {dataa.casteSc7 >= 0 ? dataa.casteSc7 : 0}</label>

                        </td>

                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                            <label> {dataa.casteSt8 >= 0 ? dataa.casteSt8 : 0}</label>

                        </td>

                        

                    </> : Number(props.parametersId) === 174 ?
                        <>

                       

                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                            <label> {dataa.genderMale4 >= 0 ? dataa.genderMale4 : 0}</label>

                        </td>

                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                            <label> {dataa.genderFemale5 >= 0 ? dataa.genderFemale5 : 0}</label>

                        </td>

                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                            <label> {dataa.genderTransgender6 >= 0 ? dataa.genderTransgender6 : 0}</label>

                        </td>

                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                            <label> {dataa.casteSc7 >= 0 ? dataa.casteSc7 : 0}</label>

                        </td>

                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                            <label> {dataa.casteSt8 >= 0 ? dataa.casteSt8 : 0}</label>

                        </td>

                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                                <label> {dataa.casteObc9 >= 0 ? dataa.casteObc9 : 0}</label>

                        </td>

                        

                    </>:
                    <>

                        <td style={{ textAlign: 'center', border: '2px solid black', padding: 10 }} >
                            <label> {dataa.genderTotal3 >= 0 ? dataa.genderTotal3 : 0}</label>

                        </td>

                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                            <label> {dataa.genderMale4 >= 0 ? dataa.genderMale4 : 0}</label>

                        </td>

                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                            <label> {dataa.genderFemale5 >= 0 ? dataa.genderFemale5 : 0}</label>

                        </td>

                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                            <label> {dataa.genderTransgender6 >= 0 ? dataa.genderTransgender6 : 0}</label>

                        </td>

                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                            <label> {dataa.casteSc7 >= 0 ? dataa.casteSc7 : 0}</label>

                        </td>

                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                            <label> {dataa.casteSt8 >= 0 ? dataa.casteSt8 : 0}</label>

                        </td>

                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                            <label> {dataa.casteObc9 >= 0 ? dataa.casteObc9 : 0}</label>
                        </td>

                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >

                            <label> {dataa.casteOthers10 >= 0 ? dataa.casteOthers10 : 0}</label>
                        </td>

                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                            <label> {dataa.vhmale11 >= 0 ? dataa.vhmale11 : 0}</label>

                        </td>

                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                            <label> {dataa.vhfemale12 >= 0 ? dataa.vhfemale12 : 0}</label>

                        </td>

                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                            <label> {dataa.vhtransgender13 >= 0 ? dataa.vhtransgender13 : 0}</label>

                        </td>

                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                            <label> {dataa.hhmale14 >= 0 ? dataa.hhmale14 : 0}</label>

                        </td>

                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                            <label> {dataa.hhfemale15 >= 0 ? dataa.hhfemale15 : 0}</label>

                        </td>

                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                            <label> {dataa.hhtransgender16 >= 0 ? dataa.hhtransgender16 : 0}</label>

                        </td>

                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                            <label> {dataa.ohmale17 >= 0 ? dataa.ohmale17 : 0}</label>

                        </td>

                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                            <label> {dataa.ohfemale18 >= 0 ? dataa.ohfemale18 : 0}</label>

                        </td>

                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                            <label> {dataa.ohtransgender19 >= 0 ? dataa.ohtransgender19 : 0}</label>

                        </td>

                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                            <label> {dataa.clmale20 >= 0 ? dataa.clmale20 : 0}</label>

                        </td>

                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                            <label> {dataa.clfemale21 >= 0 ? dataa.clfemale21 : 0}</label>

                        </td>

                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                            <label> {dataa.cltransgender22 >= 0 ? dataa.cltransgender22 : 0}</label>

                        </td>

                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                            <label> {dataa.mrmale23 >= 0 ? dataa.mrmale23 : 0}</label>

                        </td>

                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                            <label> {dataa.mrfemale24 >= 0 ? dataa.mrfemale24 : 0}</label>

                        </td>

                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                            <label> {dataa.mrtransgender25 >= 0 ? dataa.mrtransgender25 : 0}</label>

                        </td>

                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                            <label> {dataa.mdmale26 >= 0 ? dataa.mdmale26 : 0}</label>

                        </td>

                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                            <label> {dataa.mdfemale27 >= 0 ? dataa.mdfemale27 : 0}</label>

                        </td>

                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                            <label> {dataa.mdtransgender28 >= 0 ? dataa.mdtransgender28 : 0}</label>

                        </td>
                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                            <label> {dataa.othersMale29 >= 0 ? dataa.othersMale29 : 0}</label>

                        </td>
                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                            <label> {dataa.othersFemale30 >= 0 ? dataa.othersFemale30 : 0}</label>

                        </td>
                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                            <label> {dataa.othersTransgender31 >= 0 ? dataa.othersTransgender31 : 0}</label>

                        </td>
                          
                        

                        </>
       
                  
         
            }</>
    );
};

export default Evolution;
